import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQueryWithReauth } from './baseQuery';
import { AlertByDayDataPoint, GetAlertsByDay, ProductWithAlert, ItemTrackersStatusSummary, AlertReportRequestParams } from 'src/types/alertReport';

export const alertReportsAPI = createApi({
    reducerPath: 'alertReportsAPI',
    baseQuery: axiosBaseQueryWithReauth({
        baseUrl: process.env.REACT_APP_API_URL
    }),
    tagTypes: ['AlertReports'],
    endpoints: (builder) => ({
        getHighestCostAlerts: builder.query<ProductWithAlert[], AlertReportRequestParams>({
            query: ({ storeId, takeCount, startDate, endDate }) => ({
                url: `Reports/HighestCostAlerts/${storeId}`,
                method: 'GET',
                params: {
                    takeCount,
                    startDate,
                    endDate
                }
            })
        }),
        getAlertsByDay: builder.query<AlertByDayDataPoint[], GetAlertsByDay>({
            query: ({ storeId, startDate, endDate }) => ({
                url: `Reports/AlertsByDay/${storeId}`,
                method: 'GET',
                params: {
                    startDate,
                    endDate
                }
            })
        }),
        getMostExpensiveTrackedProducts: builder.query<ProductWithAlert[], AlertReportRequestParams>({
            query: ({ storeId, takeCount, startDate, endDate }) => ({
                url: `Reports/GetMostExpensiveTrackedProducts/${storeId}`,
                method: 'GET',
                params: {
                    takeCount,
                    startDate,
                    endDate
                }
            })
        }),
        getMostAlertedProducts: builder.query<ItemTrackersStatusSummary[], AlertReportRequestParams>({
            query: ({ storeId, takeCount, startDate, endDate }) => ({
                url: `Reports/MostAlertedProducts/${storeId}`,
                method: 'GET',
                params: {
                    takeCount,
                    startDate,
                    endDate
                }
            })
        })
    }),
});

export const {
    useGetHighestCostAlertsQuery,
    useGetAlertsByDayQuery,
    useGetMostExpensiveTrackedProductsQuery,
    useGetMostAlertedProductsQuery
} = alertReportsAPI;
